<template>
  <div>
    <PageTitle title="Hacker News: Top" />
    <PostList source="https://hacker-news.firebaseio.com/v0/topstories.json"/>
  </div>
</template>

<script>
import PostList from '@/components/PostList'
import PageTitle from '@/components/PageTitle'
export default {
  name: 'Top',
  components: {
    PageTitle,
    PostList
  }
}
</script>
